export const CONFIGURATIONS_FETCH = 'CONFIGURATIONS_FETCH';
export const CONFIGURATIONS_FETCH_FAILURE = 'CONFIGURATIONS_FETCH_FAILURE';
export const CONFIGURATIONS_FETCH_SUCCESS = 'CONFIGURATIONS_FETCH_SUCCESS';
export const CONFIGURATION_DETAIL_FETCH = 'CONFIGURATION_DETAIL_FETCH';
export const CONFIGURATION_DETAIL_FETCH_FAILURE =
  'CONFIGURATION_DETAIL_FETCH_FAILURE';
export const CONFIGURATION_DETAIL_FETCH_SUCCESS =
  'CONFIGURATION_DETAIL_FETCH_SUCCESS';
export const PAYMENT_METHODS_FETCH = 'PAYMENT_METHODS_FETCH';
export const PAYMENT_METHODS_FETCH_FAILURE = 'PAYMENT_METHODS_FETCH_FAILURE';
export const PAYMENT_METHODS_FETCH_SUCCESS = 'PAYMENT_METHODS_FETCH_SUCCESS';
export const CREATE_CONFIGURATION = 'CREATE_CONFIGURATION';
export const CREATE_CONFIGURATION_FAILURE = 'CREATE_CONFIGURATION_FAILURE';
export const CREATE_CONFIGURATION_SUCCESS = 'CREATE_CONFIGURATION_SUCCESS';
export const REMOVE_CONFIGURATION = 'REMOVE_CONFIGURATION';
export const REMOVE_CONFIGURATION_SUCCESS = 'REMOVE_CONFIGURATION_SUCCESS';
export const REMOVE_CONFIGURATION_FAILURE = 'REMOVE_CONFIGURATION_FAILURE';
export const CONFIGURATION_UPDATE = 'CONFIGURATION_UPDATE';
export const CONFIGURATION_UPDATE_FAILURE = 'CONFIGURATION_UPDATE_FAILURE';
export const CONFIGURATION_UPDATE_SUCCESS = 'CONFIGURATION_UPDATE_SUCCESS';
export const PAYMENT_METHOD_CATEGORIES_FETCH =
  'PAYMENT_METHOD_CATEGORIES_FETCH';
export const PAYMENT_METHOD_CATEGORIES_FETCH_SUCCESS =
  'PAYMENT_METHOD_CATEGORIES_FETCH_SUCCESS';
export const PAYMENT_METHOD_CATEGORIES_FETCH_FAILURE =
  'PAYMENT_METHOD_CATEGORIES_FETCH_FAILURE';
export const OUTLET_FETCH = 'OUTLET_FETCH';
export const OUTLET_FETCH_FAILURE = 'OUTLET_FETCH_FAILURE';
export const OUTLET_FETCH_SUCCESS = 'OUTLET_FETCH_SUCCESS';
